module.exports = __webpack_public_path__ + "static/media/password.aa35e529.png";